import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Api from "../../shared/api/api";
import { useMedia } from "./MediaContext";
import YouTubeChannelButton from "./YouTubeChannelButton";
import VideoDescription from "./VideoDescription";
import { trackEvent } from "../../shared/helpers/analytics";
import "../publishing/styles/YouTubeSection.css";

export default function VideoDetail({ scope = "author", videoId }) {
  const params = useParams();
  const id = videoId || params.id;
  const { config, loading: settingsLoading, error: settingsError } = useMedia();
  const [video, setVideo] = useState(null), [error, setError] = useState(""), [loading, setLoading] = useState(true), [retry, setRetry] = useState(0);
  const enabled = scope === "author" ? config?.blog.videosEnabled : config?.entertainment.enabled && config.entertainment.pages.videos.enabled;
  const base = scope === "author" ? "/blog" : "/avwakinentertainment";
  useEffect(() => {
    let active = true;
    if (settingsLoading || !enabled) return;
    setLoading(true); setError(""); setVideo(null);
    Api.request(`youtube/videos/${encodeURIComponent(id || "")}`, { scope }).then(data => { if (active) setVideo(data.video); }).catch(failure => { if (active) setError(failure.status === 404 ? "This video is not available." : "This video could not be loaded. Please try again."); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [scope, id, enabled, settingsLoading, retry]);
  useEffect(() => {
    if (!video) return;
    const previous = document.title; document.title = `${video.title} | ${scope === "author" ? "Kenneth L. Powell" : "Avwakin Entertainment"}`;
    return () => { document.title = previous; };
  }, [video, scope]);
  return <article className="videoDetail">
    <Link to={`${base}/videos`}>← All videos & Shorts</Link>
    {settingsLoading ? <p role="status">Loading…</p> : settingsError || !enabled ? <><h1>Page unavailable</h1><p>{settingsError || "This video section is currently turned off."}</p></> : <>
      {loading && <p role="status">Loading video…</p>}
      {error && <div role="alert"><p>{error}</p><button onClick={() => setRetry(value => value + 1)}>Try again</button></div>}
      {video && <><h1>{video.title}</h1>{video.publishedAt && <time dateTime={video.publishedAt}>{new Date(video.publishedAt).toLocaleDateString(undefined, { dateStyle: "long" })}</time>}
        <div className="videoDetailPlayer">{video.embeddable ? <iframe src={`https://www.youtube-nocookie.com/embed/${video.id}`} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" /> : <a href={video.url} onClick={() => { if (scope === "entertainment") trackEvent("entertainment_youtube_click"); }} target="_blank" rel="noopener noreferrer">Watch this video on YouTube ↗</a>}</div>
        <YouTubeChannelButton scope={scope} /><VideoDescription text={video.description || ""} /></>}
    </>}
  </article>;
}
